import { render, staticRenderFns } from "./securityInspector.vue?vue&type=template&id=12bf61ae"
import script from "./securityInspector.vue?vue&type=script&lang=js"
export * from "./securityInspector.vue?vue&type=script&lang=js"
import style0 from "./securityInspector.vue?vue&type=style&index=0&id=12bf61ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports